/** @module csi/view/customview/SaveController */
define([
	"dojo/_base/declare",
	"csi/action/Controller",
	"./_DefaultControllerMixin"
], function(declare, Controller, _DefaultControllerMixin) {

	return declare([Controller, _DefaultControllerMixin], {
		/**
		 * @override
		 * Write operations to save and select new custom view
		 */
		toWriter() {
			const {widget} = this;
			const customView = widget.customViewApplied.copy();
			widget.getModifiedCustomViewValues(customView.values);
			this._saveCustomView(customView);
		},

		/**
		 * @override
		 * Apply new custom view to store and view
		 */
		postProcessSuccess() {
			const {widget, _changedViews} = this;

			// add the view to the store
			this._applyCustomViewChangesToStore();

			// select the new view
			widget.set("customViewDirty", false);
			widget.set("customViewApplied", _changedViews[widget.customViewId]);
		}
	});
});